import api from "../api/axios";

export const COOKIE_KEY = "cookieConsentSaved";
export const ANON_KEY = "anonymousId";
export const COOKIE_DATA_KEY = "cookieConsentData";
export const COOKIE_CONSENT_EVENT = "cookie-consent-updated";

export const getAnonymousId = () => {
  let id = localStorage.getItem(ANON_KEY);

  if (!id) {
    id = `anon_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(ANON_KEY, id);
  }

  return id;
};

export const getStoredCookieConsent = () => {
  const raw = localStorage.getItem(COOKIE_DATA_KEY);

  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const saveCookieConsentLocally = (payload) => {
  localStorage.setItem(COOKIE_KEY, "true");
  localStorage.setItem(COOKIE_DATA_KEY, JSON.stringify(payload));

  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_EVENT, {
      detail: payload,
    })
  );
};

export const syncCookieConsentToBackend = async (payload) => {
  return api.post(
    "/customer/users/cookie-consent",
    {
      anonymous_id: getAnonymousId(),
      ...payload,
    },
    {
      // Consent is valid for guests, so an authentication failure must never
      // send the shopper away from the page where they made their choice.
      skipAuthRedirect: true,
    }
  );
};

export const syncCookieConsentToUser = async () => {
  const storedConsent = getStoredCookieConsent();

  if (!storedConsent) return;

  await syncCookieConsentToBackend(storedConsent);
};
